import { Transaction } from '../../types/api'
import * as types from './types'

export const setTransactions = (transactions: Array<Transaction>) => ({
    type: types.SET_TRANSACTIONS,
    payload: transactions,
})
